import { DuplicateEntitiesAPIType } from "shared/types/Project"

import { createSerializer } from "./createSerializer"
import { mapTypenameToAPIType } from "./mapTypenameToAPIType"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function dupliateEntitiesSerializer(data: any, headers: Headers) {
  return createSerializer(DuplicateEntitiesAPIType)(
    {
      ...data,
      source: data.source
        ? { ...data.source, type: mapTypenameToAPIType(data.source.type) }
        : undefined,
      target: data.target
        ? { ...data.target, type: mapTypenameToAPIType(data.target.type) }
        : undefined
    },
    headers
  )
}
